/**
 * Stay pricing helpers. Room `price` / `taxes` from catalog UI are per-night averages.
 */

export function getStayNightsFromDates(dates) {
  if (!dates) return 1;

  const raw = dates.duration;
  if (typeof raw === 'number' && raw > 0) {
    return Math.floor(raw);
  }
  if (typeof raw === 'string') {
    const parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed;
  }

  const inRaw = dates.checkInDate;
  const outRaw = dates.checkOutDate;
  if (inRaw && outRaw) {
    const checkIn = inRaw instanceof Date ? inRaw : new Date(inRaw);
    const checkOut = outRaw instanceof Date ? outRaw : new Date(outRaw);
    if (!Number.isNaN(checkIn.getTime()) && !Number.isNaN(checkOut.getTime())) {
      return Math.max(1, Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24)));
    }
  }

  return 1;
}

/** Sum per-night room lines × nights × quantity. */
export function computeStayTotalsFromRooms(rooms, nights = 1) {
  const n = Math.max(1, Math.floor(Number(nights) || 1));
  let roomSubtotal = 0;
  let taxes = 0;

  for (const room of rooms || []) {
    const qty = Math.max(1, Math.floor(Number(room.quantity) || 1));
    roomSubtotal += (Number(room.price) || 0) * qty * n;
    taxes += (Number(room.taxes) || 0) * qty * n;
  }

  return {
    nights: n,
    roomSubtotal,
    taxes,
    total: roomSubtotal
  };
}

export function buildStayPricingPayload(rooms, dates) {
  const nights = getStayNightsFromDates(dates);
  const totals = computeStayTotalsFromRooms(rooms, nights);
  return {
    nights,
    roomPrice: totals.roomSubtotal,
    taxes: totals.taxes,
    total: totals.total
  };
}
